import { FC } from 'react';
import { useField } from 'react-final-form';
import styled, { keyframes } from 'styled-components/macro';
import { TYPOGRAPHY } from '../../../assets/styles';

interface FieldErrorProps {
  name: string;
  className?: string;
}

export const FieldError: FC<FieldErrorProps> = ({ name, className }) => {
  const { meta } = useField(name, { subscription: { touched: true, error: true } });

  if (!meta.touched || !meta.error) return null;

  return <ErrorText className={className}>{meta.error}</ErrorText>;
};

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ErrorText = styled.div`
  ${TYPOGRAPHY.captionRegular12}
  color: var(--color12);
  margin-bottom: 12px;
  animation: ${fadeIn} 0.2s ease-out;
`;
